import type { OrderEvent } from "@/lib/orders";

const LABEL: Record<string, string> = {
  created: "Created",
  updated: "Edited",
  approval_requested: "Approval requested",
  approved: "Discount approved",
  rendered: "PDF rendered",
  sent_whatsapp: "Sent on WhatsApp",
  sent_email: "Sent by email",
  link_opened: "Customer opened the link",
  otp_sent: "Code sent",
  otp_verified: "Code verified",
  signed: "Signed",
  cancelled: "Cancelled",
  converted: "Converted to project",
  id_uploaded: "ID photo uploaded",
  id_deleted: "ID photo deleted",
  revised: "Revision",
  assigned: "Assigned to",
  payment_requested: "Payment link created",
  payment_paid: "Payment received",
  payment_expired: "Payment link expired",
  payment_recorded: "Payment recorded",
  crm_invoice_created: "Invoice created in CRM",
  crm_invoice_failed: "CRM invoice failed",
};

function detail(e: OrderEvent): string {
  const m = e.meta ?? {};
  const parts: string[] = [];
  if (typeof m.to === "string") parts.push(m.to);
  if (typeof m.channel === "string") parts.push(m.channel);
  if (typeof m.mode === "string") parts.push(m.mode);
  if (typeof m.result === "string" && m.result !== "sent") parts.push(m.result);
  if (typeof m.reason === "string") parts.push(m.reason);
  if (typeof m.pct === "number") parts.push(`${Math.round(m.pct)}%`);
  if (typeof m.from === "string") parts.push(`from ${m.from}`);
  if (typeof m.to === "string" && e.kind === "revised") parts.push(`to ${m.to}`);
  if (typeof m.side === "string") parts.push(m.side);
  if (typeof m.kind === "string" && (String(e.kind).startsWith("payment") || String(e.kind).startsWith("crm_invoice"))) parts.push(m.kind);
  if (typeof m.invoiceNo === "string") parts.push(m.invoiceNo);
  if (m.auto === true) parts.push("automatic, after payment");
  if (typeof m.amount === "number") parts.push(`AED ${m.amount.toLocaleString("en-US", { minimumFractionDigits: 2 })}`);
  if (typeof m.method === "string") parts.push(m.method.replace("_", " "));
  return parts.join(" · ");
}

export function Timeline({ events }: { events: OrderEvent[] }) {
  const shown = events.filter((e) => e.kind !== "rendered" || events.filter((x) => x.kind === "rendered").at(-1) === e);
  return (
    <section className="glass-panel mt-4 p-5">
      <div className="brand-kicker">Timeline</div>
      <ol className="mt-3 space-y-2 text-sm">
        {[...shown].reverse().map((e) => (
          <li key={e.id} className="flex gap-3 border-b border-white/8 pb-2 last:border-0">
            <span className="num w-32 shrink-0 text-[0.7rem] text-ice/50">
              {new Date(e.createdAt).toLocaleString("en-GB", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit", timeZone: "Asia/Dubai" })}
            </span>
            <span className="text-paper/90">{LABEL[e.kind] ?? e.kind}</span>
            <span className="min-w-0 truncate text-ice/55">{detail(e)}</span>
          </li>
        ))}
      </ol>
    </section>
  );
}
